export const ID = '5ae7a810-5721-4f96-99a8-efa681efa9e4';

export const NAME = 'StorageMart Checkout Confirmation Total Recall';
